// jquery-plugin.js
import $ from 'jquery';

const jQueryPlugin = {
  install(Vue) {
    Vue.prototype.$jquery = $;
  }
};

export default jQueryPlugin;
